package pwgs.ui.scenes.projectinvitations

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class AProjectInvitationsControllerFe(props: pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneProps, scene: MProjectInvitationsScene)
 : AController<pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneProps, pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneModel, ProjectInvitationsSceneState>(props, scene) {

    val backend = ProjectInvitationsControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    fun call_inviteUser() {
        launchOnDefaultControllerScope {
            render(backend.inviteUser())
        }
    }

    fun call_revokeInvitation(id: kotlin.String) {
        launchOnDefaultControllerScope {
            render(backend.revokeInvitation(id))
        }
    }

    fun call_resendInvitation(id: kotlin.String) {
        launchOnDefaultControllerScope {
            render(backend.resendInvitation(id))
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class ProjectInvitationsControllerBeProxy(private val controller: AProjectInvitationsControllerFe) {

    suspend fun load(): pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.projectinvitations.ProjectInvitationsControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneModel.serializer())
        }
    }

    suspend fun inviteUser(): pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.projectinvitations.ProjectInvitationsControllerBe.inviteUser",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneModel.serializer())
        }
    }

    suspend fun revokeInvitation(id: kotlin.String): pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneModel {
        @Serializable
        class ParamsWrapper(val id: kotlin.String)
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper(id))
        val p = RmiParams(
            action = "pwgs.ui.scenes.projectinvitations.ProjectInvitationsControllerBe.revokeInvitation",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneModel.serializer())
        }
    }

    suspend fun resendInvitation(id: kotlin.String): pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneModel {
        @Serializable
        class ParamsWrapper(val id: kotlin.String)
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper(id))
        val p = RmiParams(
            action = "pwgs.ui.scenes.projectinvitations.ProjectInvitationsControllerBe.resendInvitation",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneModel.serializer())
        }
    }

}
